export default __webpack_public_path__ + "img/4a407f71a81c6216ff0f7a506c7528fd.svg";